import { Controller } from "@hotwired/stimulus";
import { useClickOutside } from "stimulus-use";

// Connects to data-controller="calendar-dropdown"
export default class extends Controller {
  static targets = ["frame", "input", "value"];
  static values = { calendarId: String };

  connect() {
    useClickOutside(this, {
      onlyVisible: true,
    });
  }

  search() {
    const params = new URLSearchParams({
      calendar_id: this.calendarIdValue,
      q: this.inputTarget.value,
      selected: this.valueTarget.value,
    });
    this.frameTarget.src = `/admin/calendar?${params.toString()}`;

    if (this.inputTarget.value == "") {
      this.valueTarget.value = "";
      this.show();
    }
  }

  hide() {
    this.frameTarget.hidden = true;
    this.inputTarget.setAttribute("aria-expanded", "false");
  }

  show() {
    this.frameTarget.hidden = false;
    this.inputTarget.setAttribute("aria-expanded", "true");
  }

  isOpen() {
    return this.frameTarget.hidden == false;
  }

  prev() {
    if (!this.isOpen()) {
      return this.show();
    }
    const prev = this.element.querySelector("[data-prev]");
    if (prev) {
      this.frameTarget.src = prev.dataset.url;
      this.inputTarget.value = prev.dataset.label;
      this.valueTarget.value = prev.dataset.value;
    }
  }

  next() {
    if (!this.isOpen()) {
      return this.show();
    }
    const next = this.element.querySelector("[data-next]");
    if (next) {
      this.frameTarget.src = next.dataset.url;
      this.inputTarget.value = next.dataset.label;
      this.valueTarget.value = next.dataset.value;
    }
  }

  select({ params }) {
    this.valueTarget.value = params.value;
    this.inputTarget.value = params.label;
    this.hide();
  }

  setAndHide() {
    if (this.inputTarget.value == "") {
      this.valueTarget.value = "";
    } else {
      const selected = this.element.querySelector("[data-selected]");
      if (selected) {
        this.inputTarget.value = selected.dataset.label;
        this.valueTarget.value = selected.dataset.value;
      }
    }
    this.hide();
  }

  selectText() {
    this.inputTarget.select();
  }

  confirm(event) {
    if (this.isOpen()) {
      event.preventDefault();
    }
    this.setAndHide();
  }

  clickOutside(event) {
    this.hide();
  }
}
